import React from "react";
import { CssTextField } from "../styles/StyledComponents";

export const DecimalTextField = ({
  value,
  onChange,
  maxDecimals = 2,
  allowNegative = false,
  ...props
}) => {
  const regex = new RegExp(`^\\d*(\\.\\d{0,${maxDecimals}})?$`);

  const handleChange = (event) => {
    const val = event.target.value;
    if (val === "" || regex.test(val)) {
      onChange(event);
    }
  };

  const handleKeyDown = (evt) => {
    const invalidKeys = ["e", "E"];
    if (!allowNegative) invalidKeys.push("-");
    if (invalidKeys.includes(evt.key) || [38, 40].includes(evt.keyCode)) {
      evt.preventDefault();
    }
  };

  return (
    <CssTextField
      {...props}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      inputMode="decimal"
    />
  );
};

export const DecimalQtyTextField = ({
  value,
  onChange,
  maxDecimals = 3,
  allowNegative = false,
  ...props
}) => {
  const regex = new RegExp(`^\\d*(\\.\\d{0,${maxDecimals}})?$`);

  const handleChange = (event) => {
    const val = event.target.value;
    if (val === "" || regex.test(val)) {
      onChange(event);
    }
  };

  const handleKeyDown = (evt) => {
    const invalidKeys = ["e", "E"];
    if (!allowNegative) invalidKeys.push("-");
    if (invalidKeys.includes(evt.key) || [38, 40].includes(evt.keyCode)) {
      evt.preventDefault();
    }
  };

  return (
    <CssTextField
      {...props}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      inputMode="decimal"
    />
  );
};
